import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Link
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { forgotPassword } from '../api/forgotPassword';

export default function LoginForm() {
  const [email, setEmail] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setErrorMsg('');
    setSuccessMsg('');
    setLoading(true);
    try {
      const response = await forgotPassword({ email });
      const { status, data, error } = response.data;

      if (status) {
        setSuccessMsg(data?.message || 'Se envió un correo con las instrucciones.');
      } else {
        setErrorMsg(error?.errorMessage || 'Ocurrió un error desconocido');
      }
    } catch (err: any) {
      setErrorMsg(
        err.response?.data?.error?.errorMessage || 'Error al conectar con el servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 500,
        mx: 'auto',
        p: 4,
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fff',
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Recuperar contraseña
      </Typography>

      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}

      {successMsg && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMsg}
        </Alert>
      )}

      <TextField
        label="Correo electrónico"
        fullWidth
        required
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 2, backgroundColor: '#000', color: '#fff', fontWeight: 'bold' }}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : 'Recuperar contraseña'}
      </Button>

      <Typography variant="body2" mb={2} mt={2} sx={{ textAlign: 'center' }}>
        <Link component={RouterLink} to="/ingreso" color="primary" underline="hover">
          Volver al inicio
        </Link>
      </Typography>
    </Box>
  );
}
